import Modal from './modal';
import { showVideoModal } from '../util/modal-helpers';

class ModalVideoPopup {
	constructor(el) {
		this.el = el;
		this.emblaInstances = [];

		this.initializeModals();
	}

	initializeModals = () => {
		const btnModalLoading = this.el.querySelector('.js__modal--loading');
		const btnModalVideo = this.el;

		if (btnModalLoading) {
			btnModalLoading.addEventListener('click', () => {
				Modal.show();

				setTimeout(() => {
					Modal.setContent('This content was set after a 2 second delay.');
				}, 2000);
			});
		}

		if (btnModalVideo) {
			btnModalVideo.addEventListener('click', (e) => {
				const videoURL = e.currentTarget.getAttribute('data-video-url');

				showVideoModal(videoURL);
			});
		}
	};
}

export default ModalVideoPopup;